module.exports = __webpack_public_path__ + "static/img/produto_p.9973420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/energy-drink/produto_p.png
// module id = 87iX
// module chunks = 0